import { useColorModeValue } from "@chakra-ui/react";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useSmallScreen from "./useSmallScreen";

function CustomStyleInjector({ children }) {
  const scrollBgColor = useColorModeValue("#fff", " #030c1b");
  const scrollThumbColor = useColorModeValue("#DBE5ED", " #fff");
  const scrollTrackColor = useColorModeValue("transparent", " #030C1A");
  const [smallScreen] = useSmallScreen();
  const location = useLocation();
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  const customScrollbar = `
  body{
    overflow-y: ${
      (url === "/messaging" && !smallScreen) ||
      (/\/trading-group/gm.test(url) && !smallScreen) //if url is /trading-group/[0-9] return true
        ? "hidden"
        : "initial"
    };
    overflow-x: hidden;
  }
     .scroll-container{
   overflow-x:hidden !important;
     }

  body::-webkit-scrollbar-track, 
  .scroll-container::-webkit-scrollbar-track,
 {
    border-radius: 10px;
    background-color: ${scrollBgColor};
   
  }

  body::-webkit-scrollbar, .scroll-container::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
  }

  body::-webkit-scrollbar-thumb, .scroll-container::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${scrollThumbColor};
  }

  body::-webkit-scrollbar-track-piece:end, .scroll-container::-webkit-scrollbar-track-piece:end {
    background: ${scrollTrackColor};
    margin-bottom: 0px; 
}

body::-webkit-scrollbar-track-piece:start, .scroll-container::-webkit-scrollbar-track-piece:start {
    background: ${scrollTrackColor};
    margin-top: 0px;
}

`;

  return (
    <>
      <style>{customScrollbar}</style>
      {children}
    </>
  );
}

export default CustomStyleInjector;
